module.exports = __webpack_public_path__ + "static/img/no_honour.36878e5c.png";